import { ROOMS } from '../../../shared/world/rooms';
import { SEATS, TABLES, type Seat, type Table } from '../../../shared/world/seats';
import type { RoomId } from '../../../shared/ids';

// 옛 스크립트(js/town.js)가 읽는 shared 표: window.G.WORLD. 옛 스크립트는 import를 못 하므로 core.js 다음에 이 파일이 먼저 실행되어 표를 둔다 (main.ts의 가져오기 순서).
// 5단계에서 town이 TypeScript가 되면 이 다리 없이 shared를 직접 가져온다.
// tablesOf(room): 장소의 테이블마다 { id, no(테이블 번호), kind, x, seats: [{ id(자리 번호 = 통신 아이디), x, y, face, back? }] }
type SeatRow = Seat & { id: number };
const tablesOf = (room: RoomId): (Table & { no: number; seats: SeatRow[] })[] =>
  TABLES.filter((t) => t.room === room).map((t) => ({ ...t, no: t.table, seats: SEATS.flatMap((s, id) => (s.table === t.table ? [{ ...s, id }] : [])) }));

(window as any).G.WORLD = { rooms: ROOMS, tablesOf, seat: (id: number) => SEATS[id] };
